module.exports = __webpack_public_path__ + "img/t3.924e8572.png";